import httpClient from '@/apis/base/httpclient';
import BaseAPI from '@/apis/base/baseApi';

class ExchangeWorkerAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = 'Business';
  controllerName = 'ExchangeWorkers';

  /**
   * Kiểm tra status hành động worker
   * nmtuan4 27.11.2023
   */
  checkStatus(param) {
    let request = {
      url: this.getAPIUrl() + `/check/${param}`,
    };
    return this.getAsync(request);
  }
}

export default new ExchangeWorkerAPI();
